module.exports = __webpack_public_path__ + "assets/img/sy-qrcode-423270ce.png";